import { Icon } from '@iconify/react/dist/iconify.js';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import CountDownCell from './CountDownCell';
import { Block, CRRender } from '@/components/crRender';
import { translate } from '@/utils/langUtils';
import { STATUS_MAP } from '@/data/status';
import { Checkbox } from '@/components/Exporter';
import useForm from '@/hooks/useForm';
import { HOSPITAL_STATUS, HOSPITAL_STATUS_COLOR } from '@/data/hospitalStatus';

const DataTable = ({ setSelectedHospital, requestStatusId, setOpednedFiles, setIsChatOpen, availableProviders }: any) => {
    const { medicalOrderId } = useParams();
    const { i18n } = useTranslation();
    const [selectedProvider, setSelectedProvider] = useState<any>(null);
    const formHandler = useForm();
    useEffect(() => {
        if (!availableProviders) return;
        let selectedProvider = availableProviders?.find((ele: any) => ele.isSelected) || null;
        handleHospitalSelect(selectedProvider);
    }, [availableProviders]);

    const handleHospitalSelect = (hospital: any) => {
        const selectedHospital = selectedProvider?.id == hospital?.id ? null : hospital;
        setSelectedProvider(selectedHospital);
        setSelectedHospital(selectedHospital);
    };

    const isAvilableToSelect = useMemo(() => false
        //    STATUS_MAP.QuotationAvailable == requestStatusId
        , [requestStatusId]);

    return (
        <div className="rd-table-wrapper">
            <table className="rd-table">
                <thead>
                    <tr>
                        <CRRender isRender={isAvilableToSelect}>
                            <th className="rd-th-checkbox"></th>
                        </CRRender>
                        <th>{translate("Required Hospitals")}</th>

                        <CRRender isRender={STATUS_MAP.RequestSubmitted < requestStatusId}>
                            <th>{translate("Prices")}</th>
                            <th>{translate("Prices-details")}</th>
                        </CRRender>

                        <th>{translate("Request Date")}</th>
                        <th>{translate("Hospital respond")}</th>
                        <th>{translate("Hospital comment")}</th>
                    </tr>
                </thead>

                <tbody>
                    {availableProviders?.map((hospital: any) =>
                        <tr key={hospital.id} className={selectedProvider?.id === hospital.id ? "rd-row-selected" : ""}>

                            <CRRender isRender={isAvilableToSelect}>
                                <td className="rd-td-checkbox">
                                    <Checkbox
                                        typeId={hospital.id}
                                        itemsList={[selectedProvider?.id]}
                                        onApply={() => handleHospitalSelect(hospital)}
                                        isDisabled={hospital?.isSelected}
                                        className="relative-checkbox"
                                    />
                                </td>
                            </CRRender>
                            <td>{hospital.name}</td>
                            <CRRender isRender={STATUS_MAP.RequestSubmitted < requestStatusId}>
                                <td className="rd-price">
                                    {!!hospital.price ? `$ ${Math.ceil(hospital.price)}` : "-"}
                                </td>
                                <td>
                                    <Block isRender={!!hospital.price} >
                                        <Link
                                            to={`/panel/broker/medical-requests/${medicalOrderId}/quotation/${hospital.id}`}
                                            state={{ hospitalId: hospital.id, hospitalPrice: hospital.price }}
                                            className="rd-file-link"
                                        >
                                            {translate("show-prices-details")} <Icon icon={`prime:arrow-${i18n.language === "en" ? "left" : "right"}`} width={20} height={20} />
                                        </Link>
                                    </Block>
                                </td>
                            </CRRender>

                            {/*time count down cell */}
                            <CountDownCell orderDate={hospital.orderDate} orderStatusId={hospital.statusId} sla={hospital.sla} providerResponseDate={hospital.providerResponseDate} />
                            <td>
                                <span className={`rd-respond-badge ${HOSPITAL_STATUS_COLOR[hospital.statusId]}`} >
                                    {translate(hospital.statusName)?.toUpperCase()}
                                </span>
                            </td>

                            <td className="rd-respond-badge-container">
                                <span className='pointer cta-click img' onClick={() => { setIsChatOpen(true); setOpednedFiles(hospital.id); }}>
                                    {translate("chat-with-provider")}
                                    <Block isRender={hospital.statusId == HOSPITAL_STATUS.InformationRequested} className="alert"></Block>
                                </span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default DataTable